
const ReportDashboardPage = () => import('@/pages/reports/ReportDashboardPage.vue')

export default [
  {
    path: 'report/:reportId',
    name: 'reportDashboard',
    component: ReportDashboardPage,
    meta: {
      authIndependent: true,
      noSideItems: true,
    },
  },
]
